import { capitalizar, nombrePeriodo, periodosRecientes } from '../lib/formato';

/** Spanish month selector (the native month input renders in the browser's locale). */
export function PeriodoSelect({
  id,
  valor,
  onChange,
  etiqueta,
}: {
  id: string;
  valor: string;
  onChange: (p: string) => void;
  etiqueta: string;
}) {
  const opciones = periodosRecientes();
  if (valor && !opciones.includes(valor)) opciones.unshift(valor);
  return (
    <div className="field" style={{ maxWidth: 260 }}>
      <label htmlFor={id}>{etiqueta}</label>
      <select id={id} value={valor} onChange={(e) => onChange(e.target.value)}>
        {opciones.map((p) => (
          <option key={p} value={p}>
            {capitalizar(nombrePeriodo(p))}
          </option>
        ))}
      </select>
    </div>
  );
}
